export default __webpack_public_path__ + "static/media/udaan.f1f3911d.jpg";